import { StateStorage } from 'zustand/middleware';

export const setCookie = (name: string, value: string, days = 7) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const secure = window.location.protocol === 'https:' ? 'Secure;' : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax; ${secure}`;
};

export const getCookie = (name: string): string => {
  return document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=');
    return parts[0].trim() === name ? decodeURIComponent(parts[1]) : r;
  }, '');
};

export const removeCookie = (name: string) => {
  setCookie(name, '', -1);
};

export const cookieStorage: StateStorage = {
  getItem: (name: string): string | null => {
    return getCookie(name) || null
  },
  setItem: (name: string, value: string): void => {
    setCookie(name, value, 7)
  },
  removeItem: (name: string): void => {
    removeCookie(name)
  },
}
